import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import usePageMeta from "@/lib/usePageMeta";
import { Image as ImageIcon } from "@phosphor-icons/react";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";

export default function Gallery() {
  usePageMeta({ title: "Gallery", path: "/gallery", description: "Recent maintenance and repair jobs across Albury and Wodonga — drag the slider on any before/after to see the transformation." });
  const [imgs, setImgs] = useState([]);
  useEffect(() => { api.get("/public/gallery").then(r => setImgs(r.data)).catch(()=>{}); }, []);
  return (
    <div data-testid="gallery-page">
      <section data-nav-theme="dark" className="bg-navy-deep text-white py-20 min-h-[60vh] flex items-center">
        <div className="max-w-7xl mx-auto px-5 md:px-8 w-full">
          <div className="eyebrow">Our work</div>
          <h1 className="font-display display-lg tracking-wide mt-3 leading-tight">Recent jobs across the region.</h1>
          <p className="mt-3 text-slate-300 max-w-2xl text-sm">Slide the handle on any before/after image to see the transformation.</p>
        </div>
      </section>
      <section data-nav-theme="light" className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        {imgs.length === 0 ? (
          <div className="text-center text-slate-500 py-10">
            <ImageIcon size={36} className="mx-auto text-slate-300"/>
            <p className="mt-3">Gallery coming soon — we're documenting every project.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {imgs.map(i => {
              const isPair = !!i.before_image_url;
              const label = i.caption || i.prompt || i.service || "";
              return (
                <div key={i.id} data-testid={`public-gal-${i.id}`} className="bg-white border border-slate-200 rounded-sm overflow-hidden group">
                  {isPair ? (
                    <BeforeAfterSlider beforeSrc={i.before_image_url} afterSrc={i.image_url} aspect="aspect-[4/3]" />
                  ) : (
                    <div className="aspect-[4/3] bg-slate-100 overflow-hidden">
                      <img src={i.image_url} alt={label} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
                    </div>
                  )}
                  {(label || i.service) && (
                    <div className="px-4 py-3 border-t border-slate-100 flex items-center justify-between gap-3">
                      <div className="min-w-0">
                        {label && <div className="text-sm font-medium text-navy truncate">{label}</div>}
                        {i.service && i.service !== label && <div className="text-[11px] uppercase tracking-wider text-slate-500 mt-0.5">{i.service}</div>}
                      </div>
                      {isPair && (
                        <span className="shrink-0 text-[10px] uppercase tracking-[0.22em] font-semibold text-navy bg-cream px-2 py-1 rounded-sm border border-navy/15">Before / After</span>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
